<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="text-xl text-primary bold text-uppercase my-5">{{$t('aboutPage.header')}}</h1>
        </div>
      </div>
      <div class="row d-flex flex-column-reverse flex-lg-row">
        <div class="col-lg-6">
          <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.section1.header')}}</h2>
          <div class="text-sm">
            <p>
              {{$t('aboutPage.section1.text1')}}
              <br><br>
              {{$t('aboutPage.section1.text2')}}
            </p>
            <ul class="list-square bold">
              <li class="mb-1">{{$t('aboutPage.section1.list1.el1')}}</li>
              <li class="mb-1">{{$t('aboutPage.section1.list1.el2')}}</li>
              <li class="mb-1">{{$t('aboutPage.section1.list1.el3')}}</li>
              <li class="mb-1">{{$t('aboutPage.section1.list1.el4')}}</li>
            </ul>
            <p>
              {{$t('aboutPage.section1.text3')}}
            </p>
            <p class="mb-4">
              {{$t('aboutPage.section1.text4')}}
            </p>
            <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.section2.header')}}</h2>
            <p>
              {{$t('aboutPage.section2.text1')}}
            </p>
            <p>
              <span class="bold">{{$t('aboutPage.section2.subhead1')}}</span><br>
              {{$t('aboutPage.section2.text2')}}
            </p>
            <p>
              <span class="bold">{{$t('aboutPage.section2.subhead2')}}</span><br>
              {{$t('aboutPage.section2.text3')}}
            </p>
            <p>
              <span class="bold">{{$t('aboutPage.section2.subhead3')}}</span><br>
              {{$t('aboutPage.section2.text4')}}
            </p>
          </div>
        </div>
        <div class="col-lg-1"></div>
        <div class="col-lg-5">
          <div v-if="$i18n.locale === 'pl'" class="mb-4 py-4">
            <p class="text-lg semi-bold text-secondary font-italic">
              "{{$t('aboutPage.quote')}}
              <br><br>Zostań ekspertem z Nissens.<br>
              Zaprasza Adam Klimek."<br><br>
            </p>
            <b-aspect aspect="16:9">
              <div class="video-holder">
                <iframe src="https://www.youtube.com/embed/kHmQJVW4Pnc"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </b-aspect>
          </div>
          <div v-else>
            <p class="text-lg semi-bold text-secondary font-italic">
              "{{$t('aboutPage.quote')}}"
            </p>
            <div v-if="$i18n.locale === 'en'" class="mt-5">
              <b-aspect aspect="16:9">
                <div class="video-holder">
                  <iframe title="vimeo-player"
                          src="https://player.vimeo.com/video/685888445?h=82c121a969"
                          width="640" height="360" frameborder="0" allowfullscreen></iframe>
                </div>
              </b-aspect>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contest mt-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div v-if="$i18n.locale === 'pl'" class="contest-info pt-5 pr-lg-5 pb-5">
              <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.competitionSection.subhead1')}}</h2>
              <p>
                {{$t('aboutPage.competitionSection.text1')}}
              </p>
              <div class="mb-4 py-4">
                <b-aspect aspect="16:9">
                  <div class="video-holder">
                    <iframe src="https://www.youtube.com/embed/pZH5AvxzK-Y" title="YouTube video player"
                            frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                  </div>
                </b-aspect>
              </div>
              <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.competitionSection.subhead2')}}</h2>
              <p v-html="$t('aboutPage.competitionSection.text2')"></p>
              <p v-html="$t('aboutPage.competitionSection.text3')"></p><br>
              <p v-html="$t('aboutPage.competitionSection.text4')"></p>
            </div>
            <div v-if="$i18n.locale === 'en'" class="contest-info pt-5 pr-lg-5 pb-5">
              <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.competitionSection.subhead1')}}</h2>
              <p>
                {{$t('aboutPage.competitionSection.text1')}}
              </p>
              <div class="mb-4 py-4">
                <b-aspect aspect="16:9">
                  <div class="video-holder">
                    <iframe title="vimeo-player"
                            src="https://player.vimeo.com/video/691278955?h=685111f088"
                            width="640" height="360" frameborder="0" allowfullscreen></iframe>
                  </div>
                </b-aspect>
              </div>
              <h2 class="text-md text-secondary mb-3">{{$t('aboutPage.competitionSection.subhead2')}}</h2>
              <p v-html="$t('aboutPage.competitionSection.text2')"></p>
              <p v-html="$t('aboutPage.competitionSection.text3')"></p><br>
              <p v-html="$t('aboutPage.competitionSection.text4')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t('menu.about'),
      meta: [
        {
          name: 'description',
          content: this.$t('aboutPage.header'),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.contest {
  background: $light-grey;
  @include media-breakpoint-up(lg) {
    background: none;
    .contest-info {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        background: $light-grey;
        z-index: -1;
        width: 50vw;
      }
    }
  }
}
.video-holder {
  height: 100%;
  ::v-deep iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
